export default {
    verb: 'didCommit',
    namespace: 'oauth',
    relation: 'm2mClient',
    description: 'Show a popup with the client id and secret',
    logic
};

async function logic({ data, dispatch, context }) {
    if (context.type === 'remove') return;
    const { client_secret, client_id, title, expiresAt } = data.message;
    const expirationDate = new Date(expiresAt);
    const expirationDateString = expirationDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
    const message = [
        'You have successfully added a new M2M Client. Copy the token now!',
        'Client ID:',
        `${client_id}`,
        'Client Secret:',
        `${client_secret}`,
        ' ',
        `⚠️ WARNING - Make sure you copy the above client secret now. We don't store it, and you will not be able to see it again. It will be valid until ${expirationDateString}, or until you rotate it.`
    ];

    dispatch(
        {
            title: `M2M Client ${title}`,
            message: message,
            okButtonText: 'CONTINUE',
            noCancelOption: true,
            okAction: () => {}
        },
        { verb: 'confirm', namespace: 'application', relation: 'user' }
    );
}
